module.exports = __webpack_public_path__ + "img/logo_square.9bc82ba8.png";